module.exports = __webpack_public_path__ + "static/media/national-2-web-regular.8f1b3988.woff2";